import React from 'react';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

function SeoTagDetails({ seoTag }) {
    return (
        <Card title="Seo Tag details">
            <TableDetailsBody>
                <Row label="Route">{seoTag.route}</Row>
                <Row label="Title">{seoTag.title}</Row>
                <Row label="Meta Description">{seoTag.meta_description}</Row>
                <Row label="Meta Keywords">{seoTag.meta_keywords}</Row>
                <Row label="OG Description">{seoTag.og_description}</Row>
                <Row label="OG Image">{seoTag.og_image}</Row>
                <Row label="OG Url">{seoTag.og_url}</Row>
                <Row label="OG Type">{seoTag.og_type}</Row>
            </TableDetailsBody>
        </Card>
    );
}

export default SeoTagDetails;
